import {
    CREATE_KNITTING_INWARD_FAILURE_DK,
    CREATE_KNITTING_INWARD_REQUEST_DK,
    CREATE_KNITTING_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_KNITTING_INWARD_DK,
    FETCH_SINGLE_KNITTING_INWARD_FAILURE_DK,
    FETCH_SINGLE_KNITTING_INWARD_REQUEST_DK,
    FETCH_SINGLE_KNITTING_INWARD_SUCCESS_DK,
    FETCH_KNITTING_INWARD_FAILURE_DK,
    FETCH_KNITTING_INWARD_REQUEST_DK,
    FETCH_KNITTING_INWARD_SUCCESS_DK,
    NAVIGATE_KNITTING_INWARD_DETAILS_DK,
    NAVIGATE_KNITTING_INWARD_DK,
    KNITTING_INWARD_USERFORM_RESET_DK,
    UPDATE_KNITTING_INWARD_FAILURE_DK,
    UPDATE_KNITTING_INWARD_REQUEST_DK,
    UPDATE_KNITTING_INWARD_SUCCESS_DK,
    DELETE_KNITTING_INWARD_REQUEST_DK,
    DELETE_KNITTING_INWARD_SUCCESS_DK,
    DELETE_KNITTING_INWARD_FAILURE_DK,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_KNITTING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID_DK,
    SET_PENDING_GRID_NAME_KNITTING_INWARD,
    FETCH_COMPLETE_KNITTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_KNITTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_KNITTING_PO_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK,
    SET_UNIT_NAME_KNITTING_INWARD_DK
} from './knittingInward.actionsType';

export const KNITTING_INWARD_DK = 'knittingInwardDK';

let initialState = {
    loading: false,
    knittingInward: [],
    pendingKnittingDC: [],
    completeKnittingDC: [],
    reportSingleKnitProgramInwardList: [],
    activeKey: 1,
    knittingInwardId: '',
    detailsId: [],
    knittingInwardMasterForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedKnittingInward: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    isKnittingInward: false,
    knittingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let knittingInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_INWARD_REQUEST_DK:
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_KNITTING_INWARD_REQUEST_DK:
        case FETCH_SINGLE_KNITTING_INWARD_REQUEST_DK:
        case UPDATE_KNITTING_INWARD_REQUEST_DK:
        case DELETE_KNITTING_INWARD_REQUEST_DK:
        case FETCH_COMPLETE_KNITTING_PO_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInward: updatePayload
            };
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingKnittingDC: updatePayload
            };
        case FETCH_COMPLETE_KNITTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completeKnittingDC: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleKnitProgramInwardList: updatePayload?.Inward
            };
        case CREATE_KNITTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                knittingInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_KNITTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingInward: updatePayload,
                knittingInwardMasterForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_KNITTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingInward: {},
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case DELETE_KNITTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedKnittingInward: {}
            };
        case FETCH_KNITTING_INWARD_FAILURE_DK:
        case FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_KNITTING_INWARD_FAILURE_DK:
        case CREATE_KNITTING_INWARD_FAILURE_DK:
        case UPDATE_KNITTING_INWARD_FAILURE_DK:
        case DELETE_KNITTING_INWARD_FAILURE_DK:
        case FETCH_COMPLETE_KNITTING_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                knittingInwardMasterForm: {
                    ...state.knittingInwardMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SET_UNIT_NAME_KNITTING_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case SET_ACTIVE_KEY_KNITTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_KNITTING_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case KNITTING_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedKnittingInward: {},
                knittingInwardId: '',
                detailsId: [],
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID_DK:
            return {
                ...state,
                knittingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_KNITTING_INWARD_DETAILS_DK:
            return {
                ...state,
                isKnittingInward: true,
                knittingInwardSelectedValue: updatePayload.knittingInwardSelectedValue
            };
        case NAVIGATE_KNITTING_INWARD_DK:
            return {
                ...state,
                isKnittingInward: false
            };
        default:
            return state;
    }
};
